"use client";

import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { loadIconSprite } from "@gogive/design-system/lib/icon-sprite";
import { TooltipProvider } from "@gogive/design-system/tooltip";
import { initCharityI18n, i18n } from "@/lib/i18n";

initCharityI18n();

export function DesignSystemInit({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    void loadIconSprite("/ds-sprite.svg");
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <TooltipProvider delayDuration={0}>{children}</TooltipProvider>
    </I18nextProvider>
  );
}
